import React from "react";
import type { TableMappingRecord } from "../model/types";

export function TableMappingsCard({ mappings }: { mappings: TableMappingRecord[] }): JSX.Element {
  return (
    <section className="tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white tw-p-6">
      <h3 className="tw-text-sm tw-font-semibold tw-text-slate-800">Table mappings</h3>
      {mappings.length === 0 ? (
        <p className="tw-mt-3 tw-text-xs tw-text-slate-500">No table mappings available.</p>
      ) : (
        <div className="tw-mt-3 tw-space-y-2">
          {mappings.slice(0, 5).map((mapping, index) => (
            <div
              key={`${mapping.target_table}-${mapping.source_table}-${index}`}
              className="tw-rounded-xl tw-border tw-border-slate-100 tw-bg-slate-50 tw-p-3 tw-text-xs tw-text-slate-700"
            >
              <p className="tw-font-semibold tw-text-slate-800">
                {`${mapping.source_table || "(source)"} -> ${mapping.target_table || "(target)"}`}
              </p>
              <p className="tw-mt-1 tw-text-slate-500">
                {mapping.data_source_name || "Unknown source"}
              </p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
